import {
    ADMINGETLANGUAGEMAPPINGLIST_SUCCESS,
    ADMINGETLANGUAGEMAPPINGLIST_FAILED,
    RESET_ADMINGETLANGUAGEMAPPINGLIST,
    LOADING_ADMINGETLANGUAGEMAPPINGLIST,
    NETWORK_ERROR_ADMINGETLANGUAGEMAPPINGLIST
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetLanguageMappingList = () => {
    return { type: RESET_ADMINGETLANGUAGEMAPPINGLIST };
};

const AdmingetLanguageMappingLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINGETLANGUAGEMAPPINGLIST });
    await adminServices
        .post("getLanguageMappingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminGetLanguageMappingListsuccess(res.data));
                    break;
                default:
                    dispatch(AdminGetLanguageMappingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINGETLANGUAGEMAPPINGLIST,
                payload: err
            });
        });
};


function AdminGetLanguageMappingListsuccess(data) {
    return {
        type: ADMINGETLANGUAGEMAPPINGLIST_SUCCESS,
        payload: data
    };
}
function AdminGetLanguageMappingListFailed(data) {
    return {
        type: ADMINGETLANGUAGEMAPPINGLIST_FAILED,
        payload: data
    };
}

export { AdmingetLanguageMappingLists, resetAdminGetLanguageMappingList }